'use client';

import { FC } from 'react';

import { AssetUtils } from '@ravago/shared/next-data-access';
import { ElementProps } from '@ravago/shared/page-data/models/base';
import { NormalizedBrand } from '@ravago/shared/page-data/models/contentful-mapped';
import { BrandHeaderNode } from '@ravago/shared/page-data/models/elements';

import { AvatarNameHeader } from '../../shared/avatar-name-header/avatar-name-header';

export const BrandHeaderElement: FC<ElementProps<BrandHeaderNode>> = ({ node, globals: { contentEntity, acceptWebp } }) => {
   const brand = contentEntity as NormalizedBrand;

   if (!brand) return null;

   return (
      <AvatarNameHeader
         theme={node.theme === 'primary' ? 'primary' : 'inverse-strong'}
         avatar={brand.producer?.logo ? AssetUtils.optimizeImageIfRequired(brand.producer.logo.url, acceptWebp) : undefined}
         name={brand.name}
      />
   );
};
